import BotaoSalvar from '../../../componentes/BotaoSalvar'
import type { EstadoSalvamento } from '../../../componentes/rotuloSalvamento'

// Barra fixa Cancelar | Salvar produto (spec 2026-09-30), logo acima da barra
// de navegacao do app (Layout: nav fixed bottom-0, ~56px). Fica DENTRO do
// <form>: o Salvar continua sendo o submit.
export default function BarraSalvar({ aoCancelar, estado }: { aoCancelar: () => void; estado: EstadoSalvamento }) {
  return (
    <div className="fixed inset-x-0 bottom-14 z-10 bg-white border-t border-slate-200 p-3 flex gap-3">
      <button type="button" onClick={aoCancelar}
        className="flex-1 rounded-lg border border-slate-300 py-2 font-medium text-slate-700">Cancelar</button>
      <BotaoSalvar estado={estado} className="flex-1 rounded-lg py-2 font-medium">Salvar produto</BotaoSalvar>
    </div>
  )
}
